var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00059 8C7.12059 8 6.40059 7.28 6.40059 6.4C6.40059 5.52 7.12059 4.8 8.00059 4.8C8.88059 4.8 9.60059 5.52 9.60059 6.4C9.60059 7.28 8.88059 8 8.00059 8ZM12.8006 6.56C12.8006 3.656 10.6806 1.6 8.00059 1.6C5.32059 1.6 3.20059 3.656 3.20059 6.56C3.20059 8.432 4.76059 10.912 8.00059 13.872C11.2406 10.912 12.8006 8.432 12.8006 6.56ZM8.00059 0C11.3606 0 14.4006 2.576 14.4006 6.56C14.4006 9.216 12.2646 12.36 8.00059 16C3.73659 12.36 1.60059 9.216 1.60059 6.56C1.60059 2.576 4.64059 0 8.00059 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.b91988f0d1c2ea248439d54125c7c89b.svg";
export { ForwardRef as ReactComponent };